import React from 'react';
import RequiredActionsChecklist from './RequiredActionsChecklist';

export default function SafeguardingBanner({
  isCritical,
  rate,
  threshold,
  actions,
  isLoading = false,
  error = ''
}) {
  if (!isCritical) return null;

  return (
    <div className="sp-alert sp-alert--critical">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <p className="sp-value" style={{ fontWeight: 700 }}>
            Immediate safeguarding review required: Attendance {rate}% (threshold {threshold}%).
          </p>
          <p className="text-xs sp-muted mt-1">
            Critical attendance breach. Complete the required actions below within 48 hours.
          </p>
        </div>
      </div>
      <div className="mt-4">
        <RequiredActionsChecklist actions={actions} isLoading={isLoading} error={error} />
      </div>
    </div>
  );
}
